export default __webpack_public_path__ + "static/media/rika_s.3f9d81c6.jpg";